module.exports = __webpack_public_path__ + "static/media/loading.01a86e93.gif";